<template>
  <v-container fluid>
    <div id="app">
      <v-app id="inspire">
        <v-dialog
          v-model="dialog"
          :retain-focus="false"
          persistent
          max-width="600px"
        >
          <template v-slot:activator="{ on }">
            <v-btn color="primary" x-small dark v-on="on">Samples</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">Sample Files</span>
            </v-card-title>
            <v-card-text>
              <v-treeview
                v-model="tree"
                :open="open"
                :items="this.localFilesArray"
                activatable
                item-key="name"
                open-on-click
                open-all
              >
                <template slot="label" slot-scope="{ item }">
                  <a :href="'/etl/' + `${item.path}`"> {{ item.name }} </a>
                  <!-- <a @click="openDialog(item)">{{ item.name }}</a> -->
                </template>

                <template v-slot:prepend="{ item, open }">
                  <v-icon v-if="item.type == 'directory'">
                    {{ open ? "far fa-folder-open" : "far fa-folder" }}
                  </v-icon>
                  <v-icon v-else>
                    {{ files[item.extension] }}
                  </v-icon>
                </template>
              </v-treeview>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialog = false"
                >Close</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-app>
    </div>
  </v-container>
</template>

<script>
import jsonFilesArray from "../../../public/etl/etl_files.json";

export default {
  data() {
    return {
      userEmail: "",
      dialog: false,
      open: ["public"],
      files: {
        // html: 'mdi-language-html5',
        // js: 'mdi-nodejs',
        // json: 'mdi-json',
        // md: 'mdi-markdown',
        ".cl2": "far fa-file-alt",
        ".zip": "far fa-file-archive",
        ".xml": "far fa-file-xml",
        ".txt": "far fa-file-alt",
        ".json": "far fa-file-json",
        ".xlsx": "far fa-file-excel",
        ".xls": "far fa-file-excel",
        ".csv": "far fa-file-excel"
      },

      tree: [],
      localFilesArray: [jsonFilesArray]
    };
  },
  created() {
    // const FS = require('fs');
    //  const PATH = require('path');
    // const dirTree = require("directory-tree");
    // // const tree = dirTree("/var/etl/OLYMPIAN_PDI");  // const tree = dirTree("../");
    //const localFiles = require.context('../../../public/', true,/^.*\.*$/);
    //this.localFilesArray.toString = function () { return JSON.stringify(this); };
    // this.localFilesArray = Array.from(
    //      new Set(this.filesArray.map(item => item) )
    //    ).map(item => {
    //      return {
    //        name: item
    //      };
    //    });
  },
  computed: {
    //  ...mapGetters(["loading", "error", "user"]),
    //  localFilesArray.toString = function () { return JSON.stringify(this); }
  },

  watch: {
    //  user(value){
    //
    //  //
    //    // if user value changes б redirect to home page
    //    if(value){
    //      this.$router.push("/landing");
    //    }
    //  }
    //
  },
  mounted() {
    //const dirTree = require("directory-tree");
    // const tree = dirTree("/var/etl/OLYMPIAN_PDI");
    //const tree = dirTree("../");
  },

  methods: {}
};
</script>

<style></style>
